// src/components/Contact.js
import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p>For any questions or feedback, please contact us at:</p>
      <p>typememo24@gmail.com</p>

    </div>
  );
};

export default Contact;
